export const loadPatientDiseasesFromLocalStorage = patientRecordId => {
  const savedData = localStorage.getItem(`patient_${patientRecordId}`)
  if (savedData) {
    try {
      const parsedData = JSON.parse(savedData)
      if (parsedData.diseases && Array.isArray(parsedData.diseases)) {
        return parsedData.diseases
      }
    } catch (e) {
      console.error('Error parsing localStorage data:', e)
    }
  }
  return []
}

export const saveToLocalStorage = (patientRecordId, expandedCards) => {
  const patientData =
    JSON.parse(localStorage.getItem(`patient_${patientRecordId}`)) || {}
  patientData.diseases = expandedCards.flatMap(category =>
    category.diseases.map(disease => ({
      id: disease.id,
      name: disease.name,
      category_id: category.id,
      family_members: disease.family_members,
      description: disease.description,
      active: disease.active,
      pivot: {
        patient_id: patientRecordId,
        disease_id: disease.id,
        family_members: JSON.stringify(disease.family_members),
        description: disease.description,
        created_at: disease.created_at,
        updated_at: disease.updated_at
      }
    }))
  )

  localStorage.setItem(
    `patient_${patientRecordId}`,
    JSON.stringify(patientData)
  )
}

export const resetLocalStorage = patientRecordId => {
  if (!patientRecordId) {
    console.error('patientRecordId no proporcionado')
    return
  }

  localStorage.removeItem('categories')
  localStorage.removeItem('accordionState')
  localStorage.removeItem(`patient_${patientRecordId}`)
  window.location.reload()
}
